import { render, staticRenderFns } from "./CaseList.vue?vue&type=template&id=2c4c5562&scoped=true"
import script from "./CaseList.vue?vue&type=script&lang=js"
export * from "./CaseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4c5562",
  null
  
)

export default component.exports